import store from '../'
import util from '../../utils'
import cookie from '../../utils/cookie'
import Vue from 'Vue'

export default {
  // 用户登录成功，存储 token
  logined(state, obj) {
    state.jwt_token = obj.jwt_token;
    state.uname = obj.uname;
  },
  getyunxin(state, obj){
    state.yunxin_json = obj;
  },
  //token失效， 清除token
  refreshToken(state, obj) {
    state.jwt_token = '';
    state.uname = '';
    state.share_uname = '';
  },
  //更新uname
  refreshShareUname(state, obj) {
    state.share_uname = obj;
  },
  //获取本地缓存token
  getLocalToken(state, obj) {
    state.jwt_token = obj;
  },
  // 更新菜单开启状态
  refreshMenuOpenStatus(state, obj) {
    state.menu_open_status = obj;
  },
  // 更新菜单开启状态
  refreshBindPhoneStatus(state, obj) {
    state.userbing_phoneStatus = obj;
  },
  // 判断是否为iphoneX
  is_iphoneX(state, obj) {
    state.is_iphoneX = obj
  },

  updateUserUID (state, loginInfo) {
      state.userUID = loginInfo.uid
      state.sdktoken = loginInfo.sdktoken
      cookie.setCookie('uid', loginInfo.uid)
      cookie.setCookie('sdktoken', loginInfo.sdktoken)
    },

    updateMyInfo (state, myInfo) {
      state.myInfo = util.mergeObject(state.myInfo, myInfo)
    },
    updateUserInfo (state, users) {
      let userInfos = state.userInfos
      users.forEach(user => {
        let account = user.account
        if (account) {
          userInfos[account] = util.mergeObject(userInfos[account], user)
        }
      })
      state.userInfos = util.mergeObject(state.userInfos, userInfos)
    },

    // updateFriends (state, friends, cutFriends = []) {
    //   const nim = state.nim
    //   state.friendslist = nim.mergeFriends(state.friendslist, friends)
    //   // state.friendslist = nim.cutFriends(state.friendslist, cutFriends)
    //   state.friendslist = nim.cutFriends(state.friendslist, friends.invalid)
    // },

  //   updateSessions (state, sessions) {
  //     const nim = state.nim
  //     state.sessionlist = nim.mergeSessions(state.sessionlist, sessions)
  //     state.sessionlist.sort((a, b) => {
  //       return b.updateTime - a.updateTime
  //     })
  //     var count = 0;
  //     state.sessionlist.forEach(item => {
  //       count+=item.unread
  //       state.sessionMap[item.id] = item
  //     })
  //     state.allunread = count
  //   },

  //   updateSysMsgUnread (state, obj) {
  //     state.sysMsgUnread = Object.assign({}, obj)
  //   },

  //   // 初始化，收到离线漫游消息时调用
  //   updateMsgs (state, msgs) {
  //     const nim = state.nim
  //     let tempSessionMap = {}
  //     msgs.forEach(msg => {
  //       let sessionId = msg.sessionId
  //       tempSessionMap[sessionId] = true
  //       if (!state.msgs[sessionId]) {
  //         state.msgs[sessionId] = []
  //       }
  //       // sdk会做消息去重
  //       state.msgs[sessionId] = nim.mergeMsgs(state.msgs[sessionId], [msg])
  //       // state.msgs[sessionId].push(msg)
  //     })
  //     store.commit('updateMsgByIdClient', msgs)
  //     for (let sessionId in tempSessionMap) {
  //       state.msgs[sessionId].sort((a, b) => {
  //         return a.time - b.time
  //       })
  //       if (sessionId === state.currSessionId) {
  //         store.commit('updateCurrSessionMsgs', {
  //           type: 'init'
  //         })
  //       }
  //     }
  //   },
  //   // 更新追加消息，追加一条消息
  //   putMsg (state, msg) {
  //     let sessionId = msg.sessionId
  //     if (!state.msgs[sessionId]) {
  //       state.msgs[sessionId] = []
  //     }
  //     store.commit('updateMsgByIdClient', msg)
  //     let tempMsgs = state.msgs[sessionId]
  //     let lastMsgIndex = tempMsgs.length - 1
  //     if (tempMsgs.length === 0 || msg.time >= tempMsgs[lastMsgIndex].time) {
  //       tempMsgs.push(msg)
  //     } else {
  //       for (let i = lastMsgIndex; i >= 0; i--) {
  //         let currMsg = tempMsgs[i]
  //         if (msg.time >= currMsg.time) {
  //           state.msgs[sessionId].splice(i, 0, msg)
  //           break
  //         }
  //       }
  //     }
  //   },

  //   // 用idClient 更新消息，目前用于消息撤回
  //   updateMsgByIdClient (state, msgs) {
  //     if (!Array.isArray(msgs)) {
  //       msgs = [msgs]
  //     }
  //     let tempTime = (new Date()).getTime()
  //     msgs.forEach(msg => {
  //       // 有idClient 且 5分钟以内的消息
  //       if (msg.idClient && (tempTime - msg.time < 1000 * 300)) {
  //         state.msgsMap[msg.idClient] = msg
  //       }
  //     })
  //   },

  //   // 更新当前会话id，用于唯一判定是否在current session状态
  //   updateCurrSessionId (state, obj) {
  //     let type = obj.type || ''
  //     if (type === 'destroy') {
  //       state.currSessionId = null
  //     } else if (type === 'init') {
  //       if (obj.sessionId && (obj.sessionId !== state.currSessionId)) {
  //         state.currSessionId = obj.sessionId
  //       }
  //     }
  //   },

  //   // 更新当前会话列表的聊天记录，包括历史消息、单聊消息等，不包括聊天室消息
  //   // replace: 替换idClient的消息
  //   updateCurrSessionMsgs (state, obj) {
  //     let type = obj.type || ''
  //     if (type === 'destroy') { // 清空会话消息
  //       state.currSessionMsgs = []
  //       state.currSessionLastMsg = null
  //       store.commit('updateCurrSessionId', {
  //         type: 'destroy'
  //       })
  //     } else if (type === 'init') { // 初始化会话消息列表
  //       if (state.currSessionId) {
  //         let sessionId = state.currSessionId
  //         let currSessionMsgs = [].concat(state.msgs[sessionId] || [])
  //         // 做消息截断
  //         let limit = 36
  //         let msgLen = currSessionMsgs.length
  //         if (msgLen - limit > 0) {
  //           state.currSessionLastMsg = currSessionMsgs[msgLen - limit]
  //           currSessionMsgs = currSessionMsgs.slice(msgLen - limit, msgLen)
  //         } else if (msgLen > 0) {
  //           state.currSessionLastMsg = currSessionMsgs[0]
  //         } else {
  //           state.currSessionLastMsg = null
  //         }
  //         state.currSessionMsgs = []
  //         let lastMsgTime = 0
  //         currSessionMsgs.forEach(msg => {
  //           // if ((msg.time - lastMsgTime) > 1000 * 60 * 5) {
  //           //   lastMsgTime = msg.time
  //           //   state.currSessionMsgs.push({
  //           //     type: 'timeTag',
  //           //     text: util.formatDate(msg.time, false)
  //           //   })
  //           // }
  //           state.currSessionMsgs.push(msg)
  //         })
  //         // store.dispatch('checkTeamMsgReceipt', state.currSessionMsgs)
  //       }
  //     } else if (type === 'put') { // 追加一条消息
  //       let newMsg = obj.msg
  //       let lastMsgTime = 0
  //       let lenCurrMsgs = state.currSessionMsgs.length
  //       if (lenCurrMsgs > 0) {
  //         lastMsgTime = state.currSessionMsgs[lenCurrMsgs - 1].time
  //       }
  //       if (newMsg) {
  //         // if ((newMsg.time - lastMsgTime) > 1000 * 60 * 5) {
  //         //   state.currSessionMsgs.push({
  //         //     type: 'timeTag',
  //         //     text: util.formatDate(newMsg.time, false)
  //         //   })
  //         // }
  //         state.currSessionMsgs.push(newMsg)
  //         // store.dispatch('checkTeamMsgReceipt', [newMsg])
  //       }
  //     } else if (type === 'concat') {
  //       // 一般用于历史消息拼接
  //       let currSessionMsgs = []
  //       let lastMsgTime = 0
  //       obj.msgs.forEach(msg => {
  //         if ((msg.time - lastMsgTime) > 1000 * 60 * 5) {
  //           lastMsgTime = msg.time
  //           currSessionMsgs.push({
  //             type: 'timeTag',
  //             text: util.formatDate(msg.time, false)
  //           })
  //         }
  //         currSessionMsgs.push(msg)
  //       })
  //       currSessionMsgs.reverse()
  //       currSessionMsgs.forEach(msg => {
  //         state.currSessionMsgs.unshift(msg)
  //       })
  //       if (obj.msgs[0]) {
  //         state.currSessionLastMsg = obj.msgs[0]
  //       }
  //       // store.dispatch('checkTeamMsgReceipt', currSessionMsgs)
  //     } else if (type === 'replace') {
  //       let msgLen = state.currSessionMsgs.length
  //       let lastMsgIndex = msgLen - 1
  //       if (msgLen > 0) {
  //         for (let i = lastMsgIndex; i >= 0; i--) {
  //           if (state.currSessionMsgs[i].idClient === obj.idClient) {
  //             state.currSessionMsgs.splice(i, 1, obj.msg)
  //             break
  //           }
  //         }
  //       }
  //     }
  //   },
  // updateLoading (state, status) {
  //     clearTimeout(state.loadingTimer)
  //     state.loadingTimer = setTimeout(() => {
  //       state.isLoading = status
  //     }, 20)
  //   },
  //   updateFullscreenImage (state, obj) {
  //     obj = obj || {}
  //     if (obj.src && obj.type === 'show') {
  //       state.fullscreenImgSrc = obj.src
  //       state.isFullscreenImgShow = true
  //     } else if (obj.type === 'hide') {
  //       state.fullscreenImgSrc = ' '
  //       state.isFullscreenImgShow = false
  //     }
  //   },
  //   updateCustomSysMsgs (state, sysMsgs) {
  //     const nim = state.nim
  //     if (!Array.isArray(sysMsgs)) {
  //       sysMsgs = [sysMsgs]
  //     }
  //     sysMsgs = sysMsgs.map(msg => {
  //       msg.showTime = util.formatDate(msg.time, false)
  //       return msg
  //     })
  //     // state.customSysMsgs = nim.mergeSysMsgs(state.customSysMsgs, sysMsgs)
  //     state.customSysMsgs = state.customSysMsgs.concat(sysMsgs)
  //     Vue.set(state, sysMsgs, state.customSysMsgs)
  //     store.commit('updateCustomSysMsgUnread', {
  //       type: 'add',
  //       unread: sysMsgs.length
  //     })
  //   },
  //   updateCustomSysMsgUnread (state, obj) {
  //     let {type, unread} = obj
  //     switch (type) {
  //       case 'reset':
  //         state.customSysMsgUnread = unread || 0
  //         break
  //       case 'add':
  //         state.customSysMsgUnread += unread
  //         break
  //     }
  //   },
  //   setNoMoreHistoryMsgs (state) {
  //     state.noMoreHistoryMsgs = true
  //   },
  //   resetNoMoreHistoryMsgs (state) {
  //     state.noMoreHistoryMsgs = false
  //   },
  //   updateSysMsgs (state, sysMsgs) {
  //     const nim = state.nim
  //     if (!Array.isArray(sysMsgs)) {
  //       sysMsgs = [sysMsgs]
  //     }
  //     sysMsgs = sysMsgs.map(msg => {
  //       msg.showTime = util.formatDate(msg.time, false)
  //       return msg
  //     })
  //     // state.sysMsgs = nim.mergeSysMsgs(state.sysMsgs, sysMsgs)
  //     state.sysMsgs = [].concat(nim.mergeSysMsgs(state.sysMsgs, sysMsgs))
  //     Vue.set(state, sysMsgs, state.sysMsgs)
  //   },
}



// WEBPACK FOOTER //
// ./src/store/mutations/index.js